import React from "react";
import { connect } from "react-redux";
import { ProductWarrantyCreateContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { Displays, Forms } from "components";
import { portalService } from "apiServices";
import { toast } from "react-toastify";

class ProductWarrantyCreateContainer extends React.Component {
  state = {};

  handleBack = () => {
    this.props.router.navigate(-1);
  };

  handleSubmit = async (values) => {
    this.setState({
      isBgLoading: true,
    });
    let params = {
      ...values,
    };
    let res = await portalService.POST_PRODUCT_WARRANTEE_JSON_CREATE(params);
    if (res && res.status === 200) {
      this.setState({
        isBgLoading: false,
      });
      toast.success("สร้างสำเร็จ");
      this.props.router.navigate(-1);
    } else {
      this.setState({
        isBgLoading: false,
      });
      toast.error(
        "สร้างรายการไม่สำเร็จ กรูณาตรวจสอบ SN, Item no และ Format ข้อมูลให้ถูกต้อง"
      );
    }
  };

  render() {
    const { authenRedux } = this.props;
    const { isBgLoading } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "product_warranty");
    return (
      <ProductWarrantyCreateContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <Forms.ProductWarrantyCreateForm
          permission={permission}
          onCancel={this.handleBack}
          onSubmit={this.handleSubmit}
        />
      </ProductWarrantyCreateContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProductWarrantyCreateContainer));
